import { NavLink } from 'react-router';

import { usePsapConfiguration } from '@/app/shell/psapConfiguration';

export function WhiteLabelLogo() {
  const psapConfiguration = usePsapConfiguration();

  const appName = psapConfiguration.psapPortalConfiguration.showAppNameInNavigation
    ? psapConfiguration.psapPortalConfiguration.appName
    : null;
  const logoSrc = `${psapConfiguration.psapPortalConfiguration.logoFolderPath}/logo.svg`;

  const baseCssClass =
    'd-flex gap-2 align-items-center me-3 text-white text-decoration-none small fw-bold';

  return (
    <NavLink
      to="/incident-list"
      end
      className={({ isActive }) => (isActive ? `${baseCssClass} active` : baseCssClass)}
    >
      <img src={logoSrc} alt="Logo" className="logo" style={{ height: '40px' }} />

      {appName}
    </NavLink>
  );
}
